/**
 * Loading state reducer
 * Manages loading states (export, download, data fetching)
 */

export const loadingReducer = (state, action) => {
  switch (action.type) {
    case 'SET_IS_LOADING_DOWNLOAD':
      return { ...state, isLoadingDownload: action.payload };
    
    case 'SET_IS_EXPORT_LOADING':
      return { ...state, isExportLoading: action.payload };
    
    default:
      return state;
  }
};

export const initialLoadingState = {
  isLoadingDownload: false,
  isExportLoading: false,
};

